import Forms from './components/Forms'
import * as formsActions from './actions'
import FormsReducer from './reducers'
import FormsSagas from './sagas'
import * as formsSelectors from './selectors'

export default Forms

export { formsActions, FormsReducer, FormsSagas, formsSelectors }
